<mat-card class="fuse-card-medium fuse-card-primary">
  <!--<mat-card-subtitle class="alertMessageCard" *ngIf="isNew()">{{ websiteGuideSubTitle }}</mat-card-subtitle>-->
  <mat-card-content>
    <div style="display: flex; flex-direction: column">
      <div style="display: flex; align-items: left; flex-direction: row; justify-content: flex-start; margin: 0.8rem">
        <div>
          <img
            src="/assets/icons8-richiedi-servizio_tonda.svg "
            style="width: 64px"
            matTooltipClass="tooltip-layout"
          />
        </div>
        <div style="padding-left: 0.1rem; padding-top: 0.8rem">
          <button mat-button color="primary" (click)="navigate()" style="font-size: 1.2rem">
            {{ websiteGuideTitle }}<mat-icon>arrow_right_alt</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
